import { EmptyInstance } from "core/features/components/mixins/empty-instance";
import { EventEmitterMixin } from "front-end/mixins/event-emitter.mixin";

export class CookiebotPreferencesLinkComponent extends EventEmitterMixin(EmptyInstance) {
    private _currentContext: JQuery = $();

    private bindEvents(): void {
        this._currentContext.on("click", e => {
            e.preventDefault();
            this.emit("click");
        });
    }

    public init(currentContext: JQuery): void {
        this._currentContext = currentContext;

        this.bindEvents();
    }
}
